import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiConflictError extends TmApiClientError {
  public name = 'TmApiConflictError'

  protected override code: TmTransportHttpErrorCode = 409
}
